import $ from 'jquery';

import renderMultiSizeInfo from './templates/multi-size-info.tpl.html';

export class MultiSizeInfo {

  isOpen = false;

  constructor( containerEl ) {
    this.containerEl = containerEl;
    this.productID = this.containerEl.querySelector( 'input[name="parentid"]' ).value;

    // Call check often and when needed.
    this.check();
    this.containerEl.addEventListener( 'finished_change_variant', () => this.check() );
    this.containerEl.addEventListener( 'fitanalytics_button_visible.acl', () => this.check() );
    window.addEventListener( 'minibasket_updated.acl', () => this.check() );

    // Update when the button changes.
    this.containerEl.addEventListener( 'fitanalytics_button_changed.acl', () => this.update() );

    // Close info if clicked outside.
    document.addEventListener( 'click', ( ev ) => {
      if ( this.isOpen && ev.target && !ev.target.closest( '.mdl_multisizeinfo' ) ) {
        this.close();
      }
    } );
  }

  check() {
    if ( this.alreadyFinished() || this.alreadyClosed() ) {
      return;
    }

    // Get buttons without a popup.
    const buttonEls = Array.from( this.containerEl.querySelectorAll( '.fitanalytics__button, .fitanalytics__button_custom' ) ).filter( buttonEl => ! buttonEl.querySelector( '.mdl_multisizeinfo' ) );
    if ( buttonEls.length <= 0 ) {
        return;
    }

    // Get current selected size.
    const selectedSizeEl = this.containerEl.querySelector( '#size_select_wrapper .en_mdl_article_detail__size-choice input.acl_js--size_choice_input:checked' );
    const selectedSizeLabel = selectedSizeEl.dataset.sizeLabel;

    // Get all sizes in basket, if available.
    const alreadyAddedSizes = [];
    window.AclMiniBasket.items.forEach( basketItem => {
      if ( basketItem.marketmodelid === this.productID && basketItem.size !== selectedSizeLabel ) {
        alreadyAddedSizes.push( basketItem.size );
      }
    } );

    // No sizes added, or the current size is already included.
    if ( alreadyAddedSizes.length <= 0 || alreadyAddedSizes.includes( selectedSizeLabel ) ) {
        return;
    }

    // Render and append Overlay.
    const multiSizeInfoHTML = renderMultiSizeInfo( { 'alreadyAddedSizes': alreadyAddedSizes } );
    buttonEls.forEach( buttonEl => {
        const placeholder = document.createElement( 'div' );
        placeholder.innerHTML = multiSizeInfoHTML;
        const multiSizeInfoEl = placeholder.firstElementChild;
        buttonEl.appendChild( multiSizeInfoEl );

        // Add click listener to infoEl.
        multiSizeInfoEl.addEventListener( 'click', ( ev ) => this.onInfoElClick( ev ) )
    });

    const variants = document.getElementById( 'variants' );
    const variantsRect = variants.getBoundingClientRect();

    if ( variantsRect.bottom < 400 || variantsRect.bottom > ( window.innerHeight || document.documentElement.clientHeight ) ) {
      window.scroll( {
        top: document.documentElement.scrollTop + variantsRect.bottom - window.innerHeight,
        behavior: 'smooth'
      } );
    }

    setTimeout( () => {
      // Check once more, if we really need to open.
      if ( this.alreadyFinished() || this.alreadyClosed() ) {
        return;
      }

      this.open();
    }, 500 );
  }

  update() {
    const finishedProductIDs = this.getFromSession( 'fitanalyticsFinishedProductsIds' );
    if ( this.productID && !this.alreadyFinished() ) {
      finishedProductIDs.push( this.productID );
    }

    sessionStorage.setItem( 'fitanalyticsFinishedProductsIds', JSON.stringify( finishedProductIDs ) );
  }

  alreadyFinished() {
    const finishedProductIDs = this.getFromSession( 'fitanalyticsFinishedProductsIds' );
    return finishedProductIDs.includes( this.productID );
  }

  alreadyClosed() {
    const closedProductIDs = this.getFromSession( 'fitanalyticsClosedProductsIds' );
    return closedProductIDs.includes( this.productID );
  }

  onInfoElClick( ev ) {
    ev.preventDefault();
    ev.stopImmediatePropagation();

    if ( ev.target && ev.target.closest( '.js_close_multisizeinfo' ) ) {
      this.close();

      let closedProductIDs = this.getFromSession( 'fitanalyticsClosedProductsIds' );
      if ( this.productID && ! this.alreadyClosed() ) {
        closedProductIDs.push( this.productID );
      }

      sessionStorage.setItem( 'fitanalyticsClosedProductsIds', JSON.stringify( closedProductIDs ) );
    }
  }

  getFromSession( key, defaultValue = [] ) {
      const foundValue = sessionStorage.getItem( key );
      return foundValue ? JSON.parse( foundValue ) : defaultValue;
  }

  open() {
    this.isOpen = true;
    this.toggleClass( 'is-active', true );
    window.requestAnimationFrame( () => {
      // Make it thread-safe.
      if ( this.isOpen ) {
        this.toggleClass( 'is-visible', true );
      }
    } );
  }

  close() {
    this.isOpen = false;
    this.toggleClass( 'is-visible', false );
    setTimeout( () => {
      // Make it thread-safe.
      if ( ! this.isOpen ) {
        this.toggleClass( 'is-active', false );
      }
    }, 250 );
  }

  toggleClass( token, force ) {
    const multiSizeInfoEls = this.containerEl.querySelectorAll( '.mdl_multisizeinfo' );
    multiSizeInfoEls.forEach( (multiSizeInfoEl) => multiSizeInfoEl.classList.toggle( token, force ) );
  }
}

export function initMultiSizeInfoHandler( containerEl ) {
  if ( containerEl ) {
    containerEl.ACL_Multi_Size_Info ??= new MultiSizeInfo( containerEl );
  }
}

document.addEventListener( 'finished_change_variant', ( ev ) => {
  initMultiSizeInfoHandler( ev.target );
} );
